import { apiClient } from '@/core/api/httpClient'


// eslint-disable-next-line complexity
const odataCall = (uri, params)=>{
  let queryParams = {}

  if (params) {
    queryParams = {
      $expand: params.expand,
    }

    if(params.$filter){
      queryParams.$filter = params.$filter;
    }

    if (params.page) {
      queryParams = {
        ...queryParams,
        $skip: (params.page - 1) * params.itemsPerPage,
        $top: params.itemsPerPage,
        $count: true,
      }
    }

    if (params.sortBy && params.sortBy.length) {
      queryParams.$orderby = params.sortBy
              .map((v,i) => (`${v.replace('.', '/')} ${params.sortDesc[i] ? 'desc' : 'asc'}`))
              .join(',');
    }
  }

  return apiClient.get(`/${uri}`, {
    params: queryParams,
  })
}

export default (uri) => ({
  // eslint-disable-next-line complexity
  getItems (params) {
    return odataCall(uri, params )
  },
})


export {
  odataCall
};
